export default {
	props: {
		channel: {
			type: Object,
			required: true
		},
		listView: {
			type: Boolean,
			required: true
		}
	},
	methods: {
		toggleChannelCard(channel) {
			channel.isOpen = !channel.isOpen;
		},

		openPopupModal(item) {
			let params = {
				title: item.marketing.cim,
				text: item.marketing.szoveg
			};

			this.$store.dispatch('productDetailsStore/setModalParameters', { params });
			this.$store.dispatch('productDetailsStore/toggle');
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/CHN01-channels/CHN01-channel.js